<template>
<div>
  <div class="feed-panel p-2 mt-3 col-12 col-md-6 border-radius">
    <h3>{{ $t('Feed Controller') }}</h3>
    Status: {{ feedStatus ? 'running' : 'stopped' }} (last updated: {{ lastUpdatedFormatted }})
    <div class="w-100 mb-3" />
    <div class="settings-button switched-colors d-inline-block mb-1" @click="stopFeed">
      <loading-spinner size="mini" class="d-inline-block mr-1" v-if="stopping" />
      {{ $t('stopFeed') }} <icon type="stop-circle" /></div>
    <div class="settings-button action-button float-none d-inline-block ml-1 mb-1" @click="startFeed">
      <loading-spinner size="mini" class="d-inline-block white float-none mr-1" v-if="starting" />
      {{ $t('startFeed') }} <icon type="play-circle" />
    </div>
    <div class="settings-button switched-colors d-inline-block ml-1 mb-1" @click="restartFeed">
      <loading-spinner size="mini" class="d-inline-block mr-1" v-if="restarting" />
      {{ $t('restartFeed') }} <icon type="play-circle" />
    </div>
    <div class="settings-button switched-colors d-inline-block ml-1 mb-1" @click="getFeedStatus">
      <loading-spinner size="mini" class="d-inline-block mr-1" v-if="loadingStatus" />
      {{ $t('getFeedStatus') }} <icon type="redo" />
    </div>
    <div class="w-100 mt-2" />
    <router-link
        v-if="dataSet"
        :to="'/library/dataset/' + dataSet + '/general'"
        target="_blank"
         class="settings-button switched-colors d-inline-block">
      {{ $t('see currently incoming data') }} <icon type="table" />
    </router-link>
    <div v-else>
      <span class="d-inline-block ml-2 darker pl-1 pr-1 border-radius">
        <icon type="exclamation-triangle" /> No dataset is connected to this feed, it won't deliver any data
      </span>
    </div>
  </div>
  <div class="list-of-sensors col-12 p-2 pt-3 mt-2">
    <h3>{{ $t('Sensors') }}</h3>
    <div class="clickable" :key="sensor.id" v-for="sensor in sensors">
      <router-link target="_blank" :to="'/library/datasource/' + sensor.id + '/general'">{{ sensor.name }}</router-link>
      <div v-if="!sensor.instances.length" class="d-inline-block ml-2 darker pl-1 pr-1 border-radius">
        <icon type="exclamation-triangle" /> This sensor isn't connected to any 3d part, it won't deliver any data
      </div>
    </div>
    <sensor-add-form
        class="mt-2"
        :organization-id="$store.getters.getDatasourceOrganization($route.params.id)"
        :teams="teams"
        :feed-id="$route.params.id"
        @sensorAdded="getAllSensors"
    />
  </div>
</div>
</template>

<script>
import SensorAddForm from "./SensorAddForm.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {SpecialUuids} from "../enum";
import {getValueForMetaFieldFromMetaSets} from "../utils";
import Icon from "@/components/Icon"
export default {
  name: "FeedEdit",
  components: {SensorAddForm, LoadingSpinner, Icon},
  props: {
    metaSets: {type: Array, required: true},
    teams: {type: Array, default: () => []}
  },
  data() {
    return {
      loadingStatus: false,
      feedStatus: '',
      stopping: false,
      starting: false,
      restarting: false,
      sensors: [],
      lastUpdated: null
    }
  },
  computed: {
    lastUpdatedFormatted() {
      const now = this.lastUpdated ? this.lastUpdated : new Date();
      return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
    },
    dataSet() {
      if(this.metaSets && this.metaSets.length) {
        return getValueForMetaFieldFromMetaSets(this.metaSets, SpecialUuids.CURRENT_FEED_DATA_TABLE_METAFIELD);
      }
      return null;
    }
  },
  beforeMount() {
    this.$store.dispatch('loadFeedsClient')
        .then(() => {
          this.getFeedStatus();
        });
    this.getAllSensors();
  },
  methods: {
    stopFeed() {
      this.stopping = true;
      this.$store.dispatch('clientStopFeed', {id: this.$route.params.id})
          .then(() => {
            const $this = this;
            setTimeout( () => {
              $this.stopping = false;
              $this.getFeedStatus();
            }, 3000)
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            console.log(e);
          })
    },
    startFeed() {
      this.starting = true;
      this.$store.dispatch('clientStartFeed', {id: this.$route.params.id})
          .then(() => {
            const $this = this;
            setTimeout( () => {
              $this.starting = false;
              $this.getFeedStatus();
            }, 6000)

          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            //console.log(e);
          })
    },
    restartFeed() {
      this.restarting = true;
      const $this = this;
      this.$store.dispatch('clientStopFeed', {id: this.$route.params.id})
          .then(() => {
            // leave the feed time enough to stop
            setTimeout( () => {
              $this.$store.dispatch('clientStartFeed', {id: this.$route.params.id})
            }, 4000)
          })
          .then(() => {
            setTimeout( () => {
              $this.restarting = false;
              $this.getFeedStatus();
            }, 6000)

          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            //console.log(e);
          })
    },
    async getFeedStatus() {
      this.loadingStatus = true;
      this.$store.dispatch('clientLoadFeedStatus', {id: this.$route.params.id})
          .then(data => {
            this.feedStatus = data.running;
            this.lastUpdated = new Date();
            this.loadingStatus = false;
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            //console.log(e);
          })
    },
    async getAllSensors() {
      await this.$store.dispatch('clientLoadMetaValues', {
        id: '02211384-1345-4421-8266-881de2bc6466', // sensor metaset
        cid: SpecialUuids.SENSOR_SOURCE_FEED_METAFIELD,
        filter: 'value eq ' + this.$route.params.id
      }).then(async data => {
        if(!data || !data.length) {
          return [];
        }
        const assetIds = data.map(item => {
          return item.targetId;
        })
        let filter = "id in '" + assetIds.join("' '") + "'";
        if(assetIds.length === 1) {
          filter = "id eq " + assetIds[0];
        }
        return await this.$store.dispatch('clientLoadAssets', {
          filter,
          include: 'instances'
        })
      }).then(sensors => {
        this.sensors = sensors;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.list-of-sensors {
  border-top: 1px solid rgba(255,255,255,0.3);
}
</style>